import { Form, InputNumber } from 'antd'
import { FC, useContext } from 'react'
import { EditableCellCtx } from '../editable-cell'

interface DmsReserveProps {}

const DmsReserve: FC<DmsReserveProps> = () => {
    const ctx = useContext(EditableCellCtx)
    return (
        <Form.Item name={'dmsReserve'} noStyle>
            <InputNumber autoFocus onBlur={ctx.onBlur} controls={false} min={0} precision={0} />
        </Form.Item>
    )
}

export default DmsReserve
